module.exports = __webpack_public_path__ + "img/HP Deathly Hallows Pt 1.5990b96b.jpeg";